import styled from "styled-components";
import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import '../../styles/common.css';
import SearchInput from "../SearchInput";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import MultiOptionCheckbox from "../MultiOptionCheckbox";
import { IAreas } from "../../types/IRegionAreaData";
import { IOption } from "../../types/IOption";

const CheckboxContainer = styled.div<{ isOpen?: boolean, displayAsDropdown?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 4px;  
  width: 100%;
  .style-border{
    border-radius: 4px;
    border: 1px solid ${({ theme, isOpen }) => !isOpen ? theme.playerDataBorder : theme.filterdropdownBorder};
}
.dropdown-border{
    border-bottom: 1px solid ${({ theme, isOpen }) => isOpen ? theme.playerDataBorder : theme.filterdropdownBorder};
}
`;

const CheckBoxItemContainer = styled.div<{ isOpen?: boolean, displayAsDropdown?: boolean }>`
    flex: 1 1 0; 
    justify-content: flex-start; 
    align-items: center; 
    gap: 8px; 
    display: flex;
// width: 100%;
    

    // border: 1px solid ${({ theme }) => theme.playerDataBorder};
    background: ${({ theme, isOpen }) => isOpen ? theme.filterdropdownBackground : theme.playerContentBackground};
`;

export const CheckboxInput = styled.label<{ checked: boolean, indeterminate?: boolean }>`    

    .label-text {       
        color:${({ theme }) => theme.NumberColor};
        font-feature-settings: 'clig' off, 'liga' off;

        / Aeonik/Body/Medium /
        font-family: Aeonik;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; / 125% /
    }
    
    .label-text.all-checked:after {      
        background-color: ${({ theme }) => theme.color};        
    }    

    & > .checkbox + span:before {
        content: '';
        position: absolute;
        top: 0px;
        left: 0px;
        width: 18px;
        height:18px;
        border-radius: 2px;
        background: ${({ checked, indeterminate }) => (indeterminate ? '#00D1A8' : checked ? '#00D1A8' : 'transparent')}; 
        border: ${({ checked, theme }) => (checked ? '1px solid #00D1A8' : `1px solid ${theme.NumberColor}`)};
    }

    // & > .input:indeterminate + span:before {
    //     width: 0px;
    //     height: 7px;
    //     border: 3px solid var(--Brand-white-500, #FFF);
    //     display: block;
    //     position: absolute;
    //     left: 8px;
    //     top: 2px;
    //     transform: rotate(90deg);
    //     /* border-top: 0px; */
    //     border-left: 0px;
    // }

    
    
    & > .checkbox + span:after {
        border: 3px solid black;
    } 
       
`;

const DropDownContainer = styled.div`
    display: grid;
    gap:8px;
`;

const DropDownListContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    // padding: 4px 4px 8px 4px;
    border-radius: 4px;    
`;

const DropDownList = styled.div`
    width: 100%;
    scrollbar-color: ${({ theme }) => `${theme.NumberColor} ${theme.playerContentBackground}`};
`;

const ToggleButton = styled.div`
    width: 24px;
    height: 24px;
    padding-right:15px;
`;

const Button = styled.div<{ isOpen?: boolean }>`

    display: flex;
    height: 40px;
    padding: 16px 16px;
    justify-content: center;
    gap: 8px;
    border-radius: 4px;
    // background: ${({ theme, isOpen }) => isOpen ? theme.filterdropdownBackground : theme.playerContentBackground};
    .btnText{
        color: var(--Warm-Grey-warm-grey-600, #7C7D79);
        text-align: center;
        font-feature-settings: 'clig' off, 'liga' off;

        /* Aeonik/Label/Large */
        font-family: Aeonik;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 18px; /* 128.571% */
    }
`;

interface FilterDropdownProps {
    options: IAreas[];
    region: string;
    type?: string;
    includeAll?: boolean;
    displayAsDropdown?: boolean;
    // onSelectionChange?: (selectedOptions: string[]) => void;
    // onStatusSelectionChange?: (selectedOptions: string[]) => void;
    defaultSelectedOptions?: number[];
    //onChange: (selectedOptions: string[],region: string) => void;
    onChange: (selectedOptions: any[], region: string) => void;
    isDisplaySearch?: boolean;
}

const FilterDropdown: React.FC<FilterDropdownProps> = ({ options, region, type,
    includeAll, displayAsDropdown, defaultSelectedOptions, onChange, isDisplaySearch = true }) => {
    const [regions, setRegions] = useState<string[]>();
    const inputRef = useRef<HTMLInputElement>(null);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [filteredOptions, setFilteredOptions] = useState(options);
    const [showAll, setShowAll] = useState<boolean>(false);
    const validDefaultSelectedOptions = defaultSelectedOptions?.filter(optionId =>
        options.some(option => option.id === optionId)
    ) ?? [];
    const [checkedOptions, setCheckedOptions] = useState<{ [key: number]: boolean }>(() => {
        const initialOptions = options.reduce(
            (acc, option) => ({ ...acc, [option.id]: false }),
            {} as { [key: number]: boolean }
        );

        validDefaultSelectedOptions.forEach((optionId) => {
            initialOptions[optionId] = true;
        });

        if (includeAll) {
            initialOptions[-1] = Object.values(initialOptions).every((value) => value);
        }

        return initialOptions;
    });


    const indeterminate = includeAll ? (
        Object.values(checkedOptions).slice(0, -1).some(checked => checked) &&
        !Object.values(checkedOptions).slice(1).every(checked => checked)
    ) : false;

    useLayoutEffect(() => {
        if (inputRef.current) {
            inputRef.current.indeterminate = indeterminate;
            inputRef.current.checked = !indeterminate && checkedOptions[-1];
        }
    }, [indeterminate, checkedOptions]);

    useEffect(() => {
        const initialOptions = options.reduce(
            (acc, option) => ({ ...acc, [option.id]: false }),
            {} as { [key: number]: boolean }
        );

        if (includeAll) {
            initialOptions[-1] = Object.values(initialOptions).every((value) => value);
        }

        setCheckedOptions(initialOptions);

        if (includeAll) {
            inputRef.current!.indeterminate = false;
            inputRef.current!.checked = false;
        }

    }, [includeAll, options]);

    useEffect(() => {
        const updatedCheckedOptions: { [key: number]: boolean } = {};

        // Set all options to false
        options.forEach(option => {
            updatedCheckedOptions[option.id] = false;
        });

        // Update selected options to true
        defaultSelectedOptions?.forEach(optionId => {
            if (options.some(option => option.id === optionId)) {
                updatedCheckedOptions[optionId] = true;
            }
        });
        if (includeAll) {
            const allOtherChecked = Object.values(updatedCheckedOptions).slice(0, -1).every(checked => checked);
            updatedCheckedOptions[-1] = allOtherChecked;
        }

        setCheckedOptions(updatedCheckedOptions);
    }, [defaultSelectedOptions, options, includeAll]);

    const handleCheckboxChange = (optionId: number) => () => {
        const updatedCheckedOptions = { ...checkedOptions, [optionId]: !checkedOptions[optionId] };
        if (includeAll && optionId === -1) {
            const allChecked = updatedCheckedOptions[-1];
            Object.keys(updatedCheckedOptions).forEach(key => {
                if (parseInt(key) !== -1) {
                    updatedCheckedOptions[parseInt(key)] = allChecked;
                }
            });
        } else {
            if (includeAll) {
                const allOtherChecked = Object.values(updatedCheckedOptions).slice(0, -1).every(checked => checked);
                updatedCheckedOptions[-1] = allOtherChecked;
            }
        }
        setCheckedOptions(updatedCheckedOptions);
        const selectedOptions = includeAll
            ? Object.keys(updatedCheckedOptions).filter(key => parseInt(key) !== -1 && updatedCheckedOptions[parseInt(key)]).map(key => key.toString())
            : Object.keys(updatedCheckedOptions).filter(key => updatedCheckedOptions[parseInt(key)]).map(key => key.toString());
        const selectedOptionsWithRegion = selectedOptions.map(option => ({
            region,
            optionId: parseInt(option)
        }));
        onChange(selectedOptionsWithRegion, region);
    };

    const toggling = (): void => setIsOpen(!isOpen);
    const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        // Filter options based on search input value
        const filtered = options.filter((option) =>
            option.name.toLowerCase().includes(value.toLowerCase())
        );
        setFilteredOptions(filtered);
    };

    const handleClear = () => {
        setFilteredOptions(options);
    };

    const handleViewAll = () => {
        setShowAll(!showAll);
    };
    const displayedOptions = showAll ? filteredOptions : filteredOptions.slice(0, 5);

    return (
        <CheckboxContainer>
            <DropDownContainer>
                <CheckBoxItemContainer isOpen={isOpen} className='style-border'>
                    <CheckboxInput checked={checkedOptions[-1]} indeterminate={indeterminate} className='checkbox-input' >
                        <input
                            type="checkbox"
                            checked={checkedOptions[-1]}
                            onChange={handleCheckboxChange(-1)}
                            ref={inputRef}
                            className="checkbox"
                        />
                        <span className={`label-text ${indeterminate ? 'all-checked' : ''}`}>{region}</span>
                    </CheckboxInput>
                    <ToggleButton>
                        {isOpen ? (
                            <RemoveIcon onClick={toggling} />
                        ) : (
                            <AddIcon onClick={toggling} />
                        )}
                    </ToggleButton>
                </CheckBoxItemContainer>
                {isOpen && (
                    <DropDownListContainer>
                        {isDisplaySearch && <SearchInput handleSearch={handleSearch} handleClear={handleClear} />}
                        <DropDownList>
                            {filteredOptions.map((option, index) => (
                                <CheckBoxItemContainer key={index + 1} isOpen={isOpen}>
                                    <CheckboxInput checked={checkedOptions[option.id]} className={`checkbox-input ${isOpen ? 'dropdown-border' : ''}`}>
                                        <input
                                            type="checkbox"
                                            checked={checkedOptions[option.id]}
                                            onChange={handleCheckboxChange(option.id)}
                                            className="checkbox"
                                        />
                                        <span className="label-text">{option.name}</span>
                                    </CheckboxInput>
                                </CheckBoxItemContainer>
                            ))}
                            {/* {filteredOptions.length > 5 && !showAll && (
                                <Button onClick={handleViewAll} isOpen={isOpen}>
                                    <span className='btnText'>View All</span>
                                </Button>
                            )} */}
                        </DropDownList>
                    </DropDownListContainer>
                )}
            </DropDownContainer>
        </CheckboxContainer>
    )
}

export default FilterDropdown
